import { BaseForStepsHelper, WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { StepsDataFromPlanHelper } from 'wizards/helpers/steps-data-from-plan-helper/steps-data-from-plan-helper';
import { ConsistencyCheckModel } from 'wizards/models/consistency-check/consistency-check-model';

export class ConsistencyCheckModelForStepsHelper extends BaseForStepsHelper {
  public static consistencyCheckFormData: ConsistencyCheckModel = null;

  public static consistencyCheckModelFromPlan(plan, settings: WizardHelpersSettings = this.DefaultSettings): ConsistencyCheckModel {
    const newPlan = plan && plan.plan;

    this.consistencyCheckFormData = new ConsistencyCheckModel();

    if (!newPlan) return this.consistencyCheckFormData;

    this.setThisValues(plan, settings);
    this.setStorageType(settings.mode, newPlan.ConnectionID);

    this.consistencyCheckFormData.whereBackupStep = StepsDataFromPlanHelper.updateWhereBackup(
      false,
      newPlan.HybridID,
      newPlan.ConnectionID
    );
    this.consistencyCheckFormData.Storages = this.storages;
    this.consistencyCheckFormData.compressionEncryptionStep =
      StepsDataFromPlanHelper.updateCompressionEncryptionFroConsistencyCheck(newPlan);
    this.consistencyCheckFormData.scheduleStep = StepsDataFromPlanHelper.updateSchedule(
      newPlan,
      plan.OverdueAfterSuccess,
      this.isCreate,
      this.isUnix,
      true
    );

    return this.consistencyCheckFormData;
  }
}
